import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  connect() {
    const currentStep = this.element.dataset['currentStep'];
    const formUuid = this.element.dataset['formUuid'];
    const url = new URL(window.location.href)
    url.searchParams.set("current_step", currentStep)
    url.searchParams.set("uuid", formUuid)
    window.history.replaceState({}, "", url)
  }
}
